module.exports = __webpack_public_path__ + "static/pegn-5d3d87d3c17316e5cea0f87e4de19e3e.png";